





























































































































import Vue, { PropType } from "vue";
import { KaiwaCard } from "@/models/KaiwaCard";

export default Vue.extend({
  name: "CardForm",
  props: {
    card: {
      type: Object as PropType<KaiwaCard>,
      default: () => ({
        title: "",
        description: "",
      }),
    },
  },
  data: () => ({
    tab: null,
    valid: true,
    titleRules: [
      (v: string) => !!v || "カード名は必須項目です",
      (v: string) =>
        (v && v.length <= 50) || "カード名は50文字以内にしてください",
    ],
    descriptionRules: [
      (v: string) =>
        !v ||
        (v && v.length <= 500) ||
        "カードの説明は500文字以内にしてください",
    ],
    convRules: [
      (v: string) =>
        !v || (v && v.length <= 200) || "例は200文字以内にしてください",
    ],
  }),
  methods: {
    onFormChange() {
      console.log("form changed");
      this.$emit("form-change");
    },
  },
});
